<template>
  <div class="box">
    <v-card class="mx-auto">
      <v-sheet
        color="grey lighten-3"
        height="50"
        style="justify-content: center; display: flex; align-items: center"
        ><p class="title mb-0">Examination</p></v-sheet
      >
      <v-card-text>
        <div class="box-exam">
          <!-- section หัวข้อ -->
          <v-row>
            <v-col cols="8">
              <p class="text-body-1 text-sm-h5 font-weight-black black--text">
                {{ title }}
              </p>
            </v-col>
            <v-col cols="4">
              <!-- <v-btn
                class="float-right"
                light
                disabled
                v-if="statusCode == 'UNPUBLISHED'"
                >ข้อสอบยังไม่เปิดให้ใช้งาน</v-btn
              >
              <v-btn
                class="float-right"
                light
                disabled
                v-else-if="statusCode == 'TOO_EARLY'"
                >ยังไม่ถึงเวลาการทำข้อสอบ</v-btn
              >
              <v-btn
                class="float-right"
                light
                disabled
                v-else-if="statusCode == 'OVERDUE'"
                >หมดเวลาการทำข้อสอบ</v-btn
              >
              <v-btn
                class="float-right"
                light
                disabled
                v-else-if="statusCode == 'LIMIT_EXCEED'"
                >จำนวนครั้งในการทำข้อสอบหมดแล้ว</v-btn
              >
              <v-btn
                class="float-right"
                light
                disabled
                v-else-if="statusCode == null"
                >กรุณารอซักครู่</v-btn
              >
              <v-btn
                class="float-right"
                :color="buttonColor"
                dark
                v-else
                @click="goToExamWeb"
                >ทำแบบทดสอบ</v-btn
              > -->
              <v-btn
                class="float-right"
                :disabled="statusCode != 'ACTIVE'"
                :color="buttonColor"
                light
                @click="confirmTakeExam"
                >ทำแบบทดสอบ</v-btn
              >
            </v-col>
          </v-row>
          <v-row no-gutters v-if="statusCode != 'ACTIVE'">
            <v-col>
              <v-alert dense text type="info" v-if="statusCode == null">
                <span>กรุณารอสักกครู่</span>
              </v-alert>
              <v-alert dense text type="warning" v-else>
                <span v-if="statusCode == 'UNPUBLISHED'"
                  >ข้อสอบยังไม่เปิดให้ใช้งาน</span
                >
                <span v-else-if="statusCode == 'TOO_EARLY'"
                  >ยังไม่ถึงเวลาการทำข้อสอบ</span
                >
                <span v-else-if="statusCode == 'OVERDUE'"
                  >หมดเวลาการทำข้อสอบ</span
                >
                <span v-else-if="statusCode == 'LIMIT_EXCEED'"
                  >จำนวนครั้งในการทำข้อสอบหมดแล้ว</span
                >
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <p
                v-if="detail.description != ''"
                class="subtitle-1 mb-0 ma-auto"
                hide-details
                v-html="'คำชี้แจง ' + detail.description"
              ></p>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-card flat outlined>
                <v-card-text>
                  <v-list-item class="pa-3">
                    <v-list-item-content class="pa-0">
                      <v-list-item-title class="ma-0 grey--text text-darken-2">
                        <p>จำนวนคำถาม</p>
                        <p>คะแนนเต็ม</p>
                        <p>จำกัดเวลาสอบ</p>
                        <p>จำนวนครั้งที่สอบไปแล้ว</p>
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="subtitle-1 ma-0 text-right">
                      <v-list-item-title class="font-weight-bold black--text">
                        <p>
                          {{ detail.totalQuestion + " ข้อ" }}
                        </p>
                        <p>{{ detail.totalScore + " คะแนน" }}</p>
                        <p :class="detail.timeUse!==0? 'timer-color':''">
                          {{
                            detail.timeUse != 0
                              ? millisecToHr(detail.timeUse) + " ชั่วโมง"
                              : "ไม่จับเวลา"
                          }}
                        </p>
                        <p>
                          {{ detail.term }} ครั้ง /
                          {{
                            detail.limited == 0 ? "ไม่จำกัด" : detail.limited
                          }}
                        </p>
                      </v-list-item-title>
                    </v-list-item-action>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- section หัวข้อ -->
          <!-- section สถิติการสอบ -->
          <v-row>
            <v-col cols="12">
              <p class="title grey--text text--darken-3">สถิติการสอบของฉัน</p>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-card class="ma-auto" flat outlined>
                <p
                  v-if="myTicket.length == 0"
                  class="subtitle-1 text-center grey--text mt-5"
                >
                  ยังไม่มีประวัติการสอบ
                </p>
                <template v-else>
                  <apexchart
                    type="bar"
                    height="250"
                    :options="examAvgChartOptions"
                    :series="examAvgSeries"
                  ></apexchart>
                </template>
              </v-card>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="4" class="text-center pa-0">
              <v-card-text class="pa-1">
                <p class="title mb-0">
                  {{ myTicket.length == 0 ? "-" : getMaxScore(myTicket) }}
                </p>
                <p class="subtitle-1 mb-0">คะแนนสูงสุด</p>
              </v-card-text>
            </v-col>
            <v-col cols="4" class="text-center pa-0">
              <v-card-text class="pa-1">
                <p class="title mb-0">
                  {{ myTicket.length == 0 ? "-" : getMinScore(myTicket) }}
                </p>
                <p class="subtitle-1 mb-0">คะแนนต่ำสุด</p>
              </v-card-text>
            </v-col>
            <v-col cols="4" class="text-center pa-0">
              <v-card-text class="pa-1">
                <p class="title mb-0">
                  {{ myTicket.length == 0 ? "-" : getLastScore(myTicket) }}
                </p>
                <p class="subtitle-1 mb-0">คะแนนล่าสุด</p>
              </v-card-text>
            </v-col>
          </v-row>
          <!-- section สถิติการสอบ -->
          <!-- section ประวัติการสอบ -->
          <v-row>
            <v-col cols="12">
              <p class="title grey--text text--darken-3">ประวัติการสอบของฉัน</p>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <p
                v-if="myTicket.length == 0"
                class="subtitle-1 text-center grey--text"
              >
                ยังไม่มีประวัติการสอบ
              </p>
              <template v-if="myTicket.length > 0">
                <template v-for="exam in myTicket">
                  <v-card :key="exam._id" class="my-3" outlined flat>
                    <v-card-text>
                      <v-list-item class="pa-2">
                        <v-list-item-content class="pa-0">
                          <v-list-item-title class="ma-0">
                            <p class="grey--text">สอบครั้งที่</p>
                            <p>วันที่</p>
                            <p>คะแนนเต็ม</p>
                            <p>คะแนนที่ได้</p>
                            <p>
                              คะแนน ({{
                                ((exam.score / exam.maxScore) * 100).toFixed(
                                  2
                                ) + " %"
                              }})
                            </p>
                            <p>ตอบถูก</p>
                            <p>ตอบผิด</p>
                            <p>ไม่ได้ตอบ</p>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="subtitle-1 ma-0 text-right">
                          <v-list-item-title>
                            <p class="grey--text">{{ exam.term + 1 }}</p>
                            <p class="grey--text">
                              {{ exam.created_at | moment("DD/MM/YYYY") }}&nbsp;
                              {{
                                new Date(exam.created_at)
                                  .toString()
                                  .substr(16, 2) + ":"
                              }}{{
                                new Date(exam.created_at)
                                  .toString()
                                  .substr(19, 2) + " น."
                              }}
                            </p>

                            <p>{{ exam.maxScore + " คะแนน" }}</p>

                            <p>
                              {{ exam.score + " คะแนน" }}
                            </p>
                            <p>
                              <v-progress-linear
                                rounded
                                height="12"
                                class="mt-2"
                                color="green"
                                :value="
                                  ((exam.score / exam.maxScore) * 100).toFixed(
                                    2
                                  )
                                "
                              >
                              </v-progress-linear>
                            </p>
                            <p class="success--text">
                              {{ exam.correct + " ข้อ" }}
                            </p>
                            <p class="error--text">
                              {{ exam.wrong + " ข้อ" }}
                            </p>
                            <p class="grey--text">
                              {{ exam.noAnswer + " ข้อ" }}
                            </p>
                          </v-list-item-title>
                        </v-list-item-action>
                      </v-list-item>
                    </v-card-text>
                  </v-card>
                </template>
              </template>
              <!-- <template v-if="myTicket.length > 0">
            <v-data-table
              :headers="headers"
              :items="myTicket"
              class="elevation-1 tbl-exam"
              hide-default-footer
            >
              <template v-slot:item.no="{ item }">
                <span>{{ item.term + 1 }}</span>
              </template>
              <template v-slot:item.date="{ item }">
                <span>
                  {{ item.created_at | moment("DD/MM/YYYY") }}&nbsp;
                  {{ new Date(item.created_at).toString().substr(16, 2) + ":" }}
                  {{
                    new Date(item.created_at).toString().substr(19, 2) + " น."
                  }}
                </span>
              </template>
              <template v-slot:item.score="{ item }">
                <span> {{ item.score }}</span>
              </template>
              <template v-slot:item.percent="{ item }">
                <v-row no-gutters>
                  <v-col cols="8">
                    <v-progress-linear
                      rounded
                      height="12"
                      class="mt-2"
                      color="green"
                      :value="((item.score / item.maxScore) * 100).toFixed(2)"
                    >
                    </v-progress-linear>
                  </v-col>
                  <v-col cols="4">
                    <p class="pt-1 grey--text">
                      {{
                        ((item.score / item.maxScore) * 100).toFixed(2) + " %"
                      }}
                    </p>
                  </v-col>
                </v-row>
                <span> </span>
              </template>
              <template v-slot:item.correct="{ item }">
                <span>{{ item.correct }}</span>
              </template>
              <template v-slot:item.wrong="{ item }">
                <span>{{ item.wrong }}</span>
              </template>
              <template v-slot:item.noanswer="{ item }">
                <span>{{ item.noAnswer }}</span>
              </template>
            </v-data-table>
          </template> -->
            </v-col>
          </v-row>
          <!-- section ประวัติการสอบ -->
        </div>
      </v-card-text>
    </v-card>
    <v-dialog v-model="confirmTakeExamDialog" scrollable max-width="450px">
      <v-card>
        <v-card-title>
          <v-row justify="center">
            <v-col class="text-center mt-2" v-if="detail.timeUse==0"><span>ยืนยันการทำข้อสอบ?</span></v-col>
            <v-col class="text-center mt-2" v-else>
              <div>
                <v-icon left size="40px" color="#FFD700">mdi-alert</v-icon>
              </div>
              <div>คำเตือน</div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-card class="pr-5 pl-5 takeExamDescript" elevation="0" v-if="detail.timeUse==0">
            หากกดเริ่มทำข้อสอบแล้ว จะไม่สามารถยกเลิกได้
          </v-card>
          <v-card class="pr-5 pl-5 takeExamDescript timer-color" elevation="0" v-else>
            เมื่อคุณกดปุ่ม "เริ่มสอบ" ตัวจับเวลาจะเริ่มนับทันที และจะยังคงนับต่อไปแม้ว่าคุณจะออกจากเว็บไซต์
          </v-card>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="confirmTakeExamDialog = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            :color="buttonColor"
            text
            @click="goToExamWeb"
          >
            เริ่มสอบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      examAvgSeries: [
        {
          name: "คะแนน ",
          data: [],
        },
      ],
      examAvgChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "30%",
          },
        },
        colors: [],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: false,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: [],
          title: {
            text: "No. of Examination",
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 4,
          title: {
            text: "Score (%)",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "%";
            },
          },
          x: {
            formatter: function (val) {
              return val;
            },
          },
        },
      },
      confirmTakeExamDialog: false
    };
  },
  computed: {
    buttonColor() {
      return Vue.prototype.$userInfo.companies[0].buttonColor;
    },
    headerColor() {
      return Vue.prototype.$userInfo.companies[0].headerColor;
    },
    dialogClassName() {
      return `dialog ${this.$store.getters.dialogExamClass}`;
    },
    hasExam() {
      return !!this.$store.getters.exam;
    },
    detail() {
      return this.$store.getters.exam.detail;
    },
    myTicket() {
      this.examAvgSeries[0].data = [];
      this.examAvgChartOptions.xaxis.categories = [];
      this.examAvgChartOptions.colors = [];

      let seriesColors = [];
      let xAxisCat = [];

      // console.log(this.$store.getters.exam.myTicket);
      let myTickets = this.$store.getters.exam.myTicket.slice().reverse();

      for (const myticket of myTickets) {
        this.examAvgSeries[0].data.push(
          ((myticket.score / myticket.maxScore) * 100).toFixed(2)
        );
        xAxisCat.push("ครั้งที่ " + (myticket.term + 1));
        seriesColors.push(Vue.prototype.$userInfo.companies[0].headerColor);
      }

      // this.examAvgChartOptions.xaxis.categories
      // this.examAvgChartOptions.colors

      let newSeries = this.examAvgSeries[0].data;
      this.examAvgSeries = [
        {
          name: "คะแนน ",
          data: newSeries,
        },
      ];
      this.examAvgChartOptions = {
        ...this.examAvgChartOptions,
        ...{
          xaxis: {
            categories: xAxisCat,
          },
          colors: seriesColors,
        },
      };
      // console.log(this.examAvgSeries, this.examAvgChartOptions);
      return this.$store.getters.exam.myTicket;
    },
    title() {
      return this.detail.title;
    },
    ticketId() {
      return this.$store.getters.ticketId;
    },
    statusCode() {
      return this.$store.getters.statusCode;
    },
    buttonCloseColor() {
      return "white";
    },
    iconCloseColor() {
      return Vue.prototype.$userInfo.companies[0].buttonColor;
    },
    headers() {
      return [
        {
          text: "ครั้งที่",
          align: "center",
          sortable: false,
          value: "no",
          class: "body-2 pt-3",
          width: "80",
        },
        {
          text: "วันที่",
          align: "center",
          sortable: false,
          value: "date",
          filterable: false,
          class: "body-2 pt-3",
          width: "180",
        },
        {
          text: "คะแนน",
          value: "score",
          sortable: false,
          filterable: false,
          align: "center",
          class: "body-2 pt-3",
          width: "80",
        },
        {
          text: "เปอร์เซ็นต์",
          align: "center",
          value: "percent",
          sortable: false,
          filterable: false,
          class: "body-2 pt-3",
          width: "220",
        },
        {
          text: "ตอบถูก",
          value: "correct",
          sortable: false,
          filterable: false,
          align: "center",
          class: "body-2 pt-3",
          width: "80",
        },
        {
          text: "ตอบผิด",
          value: "wrong",
          sortable: false,
          filterable: false,
          align: "center",
          class: "body-2 pt-3",
          width: "80",
        },
        {
          text: "ไม่ตอบ",
          value: "noanswer",
          sortable: false,
          filterable: false,
          align: "center",
          class: "body-2 pt-3",
          width: "80",
        },
      ];
    },
  },
  methods: {
    close() {
      this.$store.commit("setDialogExamClass", "close");
      setTimeout(() => {
        this.$store.commit("setDialogExamClass", "");
      }, 500);
    },
    confirmTakeExam(){
      this.confirmTakeExamDialog = true
    },
    async goToExamWeb() {
      await this.$store.dispatch("goToExamWeb");
      this.close();
      location.reload();
    },
    millisecToHr(time) {
      // console.log(time);
      if (time) {
        let totalSeconds = time / 1000;
        let hours = Math.floor(totalSeconds / 3600);
        totalSeconds %= 3600;
        let minutes = Math.floor(totalSeconds / 60);
        let seconds = totalSeconds % 60;

        hours = hours < 10 ? `0${hours}` : `${hours}`;
        minutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
        seconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${hours}:${minutes}:${seconds}`;
      } else {
        return "00:00:00";
      }
    },
    getMinScore(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr.reduce(
        (min, p) => (p.score < min ? p.score : min),
        Infinity
      );
    },
    getMaxScore(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr.reduce((max, p) => (p.score > max ? p.score : max), 0);
    },
    getAvg(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr.reduce((a, b) => a + b.score) / scoreArr.length;
    },
    getLastScore(scoreArr) {
      if (scoreArr.length == 0) return 0;
      return scoreArr[0].score || 0;
      // return scoreArr[scoreArr.length - 1].score;
    },
  },
};
</script>
<style scoped>
.box-exam {
  background-color: #ffffff;
  /* position: absolute; */
  /* display: block; */
  width: 100%;
}
.v-data-table.tbl-exam {
  max-width: 500px;
  /* min-width: 500px; */
}
.takeExamDescript{
  color:grey
}
.timer-color {
  color: red
}
</style>
<style>
.box-exam .tbl-exam > .v-data-table__wrapper > table > tbody > tr > td {
  padding-top: 10px;
}
.main-layout.course .box .box-exam .v-alert__icon.v-icon {
  font-size: 15px;
  margin-right: 8px;
}
</style>